import UserApi from '@/api/user';
import TiersApi from '@/api/tiers';
import StoreBuilder from '../store-builder';

const builder = new StoreBuilder('user');
builder.addStatePart('user', null, () => UserApi.getProfil());
builder.addStatePart('sessionInfos', {}, null, 'SESSION');
builder.addStatePart('connectedAs', null, null, 'SESSION');
builder.addStatePart('tiers', null, (numTiers) => TiersApi.getTiers(numTiers), 'SESSION');

builder.setGetters({
  numTiers: state => state.connectedAs ? state.connectedAs : state.user.username
});
builder.setActions({
  loadTiers: ({ commit, state }, args) => {
    const numTiers = state.connectedAs ? state.connectedAs : state.user.username;
    return TiersApi.getTiers(numTiers).then(tiers => {
      commit('SET_TIERS', tiers);
      return tiers;
    });
  }
});

export default builder.build();
